// ClipboardWrapper: Provides clipboard functionality with testability
// In production: uses navigator.clipboard.writeText
// In tests: also sets window.lastCopiedText for easy verification

export async function writeText(text) {
  // Store for test verification
  window.lastCopiedText = text;

  // Use the real Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }

  // Fallback for older browsers
  return Promise.resolve();
}
